module.exports = __webpack_public_path__ + "static/media/brussels-sprouts.60805d5e.png";